import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const POLL_INTERVAL = 60000;

const getHelsinkiNow = () => {
  return new Date().toLocaleString('sv-SE', {
    timeZone: 'Europe/Helsinki',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  });
};

const useBadges = (userId) => {
  const [shopBadge, setShopBadge] = useState(false);
  const [shopBadgeTab, setShopBadgeTab] = useState(null);
  const [achievementsBadge, setAchievementsBadge] = useState(false);
  const [achievementsBadgeCount, setAchievementsBadgeCount] = useState(0);

  const checkBadges = useCallback(async () => {
    if (!userId) return;

    try {
      const lastSeenShop = localStorage.getItem(`lastSeenShopAt_${userId}`) || '1970-01-01 00:00:00';
      const lastSeenAchievements = localStorage.getItem(`lastSeenAchievementsAt_${userId}`) || '1970-01-01 00:00:00';

      const res = await api.get(`/badges?achievements_since=${encodeURIComponent(lastSeenAchievements)}`);
      const data = res.data;

      if (data.shop_latest && data.shop_latest > lastSeenShop) {
        setShopBadge(true);
        setShopBadgeTab(data.shop_latest_tab);
      } else {
        setShopBadge(false);
        setShopBadgeTab(null);
      }

      if (data.achievements_count_unseen > 0) {
        setAchievementsBadge(true);
        setAchievementsBadgeCount(data.achievements_count_unseen);
      } else {
        setAchievementsBadge(false);
        setAchievementsBadgeCount(0);
      }
    } catch {
      // Silent fail
    }
  }, [userId]);

  const markShopSeen = useCallback(() => {
    if (!userId) return;
    localStorage.setItem(`lastSeenShopAt_${userId}`, getHelsinkiNow());
    setShopBadge(false);
    setShopBadgeTab(null);
  }, [userId]);

  const markShopTabSeen = useCallback(() => {
    setShopBadgeTab(null);
  }, []);

  const markAchievementsSeen = useCallback(() => {
    if (!userId) return;
    localStorage.setItem(`lastSeenAchievementsAt_${userId}`, getHelsinkiNow());
    setAchievementsBadge(false);
    setAchievementsBadgeCount(0);
  }, [userId]);

  useEffect(() => {
    checkBadges();
    const interval = setInterval(checkBadges, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, [checkBadges]);

  return {
    shopBadge,
    shopBadgeTab,
    achievementsBadge,
    achievementsBadgeCount,
    markShopSeen,
    markShopTabSeen,
    markAchievementsSeen,
    refreshBadges: checkBadges,
  };
};

export default useBadges;
